import { NextPageContext } from 'next'
import dynamic from 'next/dynamic'
import { GeneralLoading } from '@hem/ui'

import { logoutMiddleware } from '~/logoutMiddleware'

const LazyLogin = dynamic(() => import('~/features/login'), {
  loading: () => <GeneralLoading />,
  ssr: false,
})

const LoginPage = () => <LazyLogin />

export const getServerSideProps = async (context: NextPageContext) => {
  return logoutMiddleware(context)
}

export default LoginPage
